import mixpanel from "mixpanel-browser";
import { shouldLogDataInSentryMixpanel } from "./constants";

const environmentCheck = process.env.NODE_ENV === "production" && shouldLogDataInSentryMixpanel();

export interface Dict {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

const actions = {
    alias: (id: string): void => {
        if (environmentCheck) {
            mixpanel.alias(id);
        }
    },
    identify: (id?: string): void => {
        if (environmentCheck) {
            if (id) {
                mixpanel.identify(id);
            } else {
                mixpanel.identify();
            }
        }
    },
    people: {
        set: (props: Dict): void => {
            if (environmentCheck) {
                mixpanel.people.set(props);
            }
        }
    },
    reset: (): void => {
        if (environmentCheck) {
            mixpanel.reset();
        }
    },
    track: (name: string, props?: Dict): void => {
        if (environmentCheck) {
            mixpanel.track(name, props);
        }
    }
};

export const MixPanel = actions;
